export interface IRequestLoadingIndicator {
    identifier: string;
    activeRequest: number;
    endedRequest: number;
}
